var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.525391 1C0.525391 0.447715 0.973106 0 1.52539 0H17.5254C18.0777 0 18.5254 0.447715 18.5254 1C18.5254 1.55228 18.0777 2 17.5254 2H1.52539C0.973106 2 0.525391 1.55228 0.525391 1ZM5.2325 5.29289C5.62302 5.68342 5.62302 6.31658 5.2325 6.70711L2.9396 9L5.2325 11.2929C5.62302 11.6834 5.62302 12.3166 5.2325 12.7071C4.84197 13.0976 4.20881 13.0976 3.81828 12.7071L0.818284 9.70711C0.42776 9.31658 0.42776 8.68342 0.818284 8.29289L3.81828 5.29289C4.20881 4.90237 4.84197 4.90237 5.2325 5.29289ZM6.34358 9C6.34358 8.44772 6.79129 8 7.34358 8H17.5254C18.0777 8 18.5254 8.44772 18.5254 9C18.5254 9.55229 18.0777 10 17.5254 10H7.34358C6.79129 10 6.34358 9.55229 6.34358 9ZM0.525407 17C0.525407 16.4477 0.973122 16 1.52541 16H17.5254C18.0777 16 18.5254 16.4477 18.5254 17C18.5254 17.5523 18.0777 18 17.5254 18H1.52541C0.973122 18 0.525407 17.5523 0.525407 17Z",
    fill: "#A4728C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamMenu);
export default __webpack_public_path__ + "static/media/hamMenu.68bd6e650334556c6e2bc9f5a4f0fa10.svg";
export { ForwardRef as ReactComponent };